import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { first, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = false;
  private loadingSub: Subscription;

  private tasks$ = [];
  public messages = [];
  public Cancel: boolean = false;
  public CancelButton: boolean = false;

  constructor() {}

  get Loading(): boolean {
    return this.loading;
  }

  public clearLoading() {
    this.loading = false;
    this.CancelButton = false;
    this.tasks$ = [];
    this.messages = [];
  }

  private waitForLoading() {
    if (this.loadingSub && !this.loadingSub.closed)
      this.loadingSub.unsubscribe();
    this.loadingSub = forkJoin(this.tasks$).subscribe((results) => {
      // console.log('All tasks complete', results);
      this.clearLoading();
    });
  }

  /**
   * Create a loading task for a minimum number of milliseconds `ms`
   * @param ms minimum number of milliseconds to show loading dialog (default: 0)
   * @param message optional message to display on loading dialog (default: '')
   * @param header optional header message to display on loading dialog (default: 'Loading...')
   */
  public createTask(
    ms: number = 0,
    message = '',
    header = 'Loading...',
    CancelButton = false
  ) {
    this.loading = true;
    const task = new BehaviorSubject<boolean>(false);
    const taskMin = new BehaviorSubject<boolean>(false);
    this.tasks$.push(
      task.pipe(
        filter((val) => val),
        first()
      ),
      taskMin.pipe(
        filter((val) => val),
        first()
      )
    );
    if (message !== null || message !== undefined)
      this.messages.push({ message, header });
    this.CancelButton = CancelButton;
    this.waitForLoading();
    if (ms > 0) setTimeout(() => taskMin.next(true), ms);
    else taskMin.next(true);
    return task;
  }

  /**
   * Complete an existing loading task
   * @param task Loading task
   */
  public completeTask(task: BehaviorSubject<boolean>) {
    if (task) {
      task.next(true);
    }
  }

  public updateMessage(message: string, header: string, index: number = null) {
    if (index === null) {
      this.messages = [];
      this.messages.push({ message, header });
    } else {
      this.messages[index] = { message, header };
    }
  }

  public cancel(task: BehaviorSubject<boolean>) {
    task.next(false);
    this.clearLoading();
  }

  public cancelTask() {
    this.Cancel = true;
    this.messages = [];
    this.messages.push({ message: '', header: 'Canceling...' });
  }
}
